import { Participant } from '@/src/domain/models';
import { Ionicons } from '@expo/vector-icons';
import { Text, TouchableOpacity, View } from 'react-native';
import { createStyles } from '../TournamentDetailScreen.styles';

interface ParticipantItemProps {
  participant: Participant;
  canManageParticipants: boolean;
  isSetup: boolean;
  isChallengeTournament?: boolean;
  onPress: (userId: string) => void;
  onDelete: (participantId: string) => void;
  colors: {
    card: string;
    border: string;
    text: string;
    textSecondary: string;
    primary: string;
    error: string;
  };
}

export const ParticipantItem = ({
  participant,
  canManageParticipants,
  isSetup,
  isChallengeTournament,
  onPress,
  onDelete,
  colors,
}: ParticipantItemProps) => {
  const styles = createStyles();
  const isRegistered = !!participant.userId;

  return (
    <TouchableOpacity
      style={[styles.participantItem, { backgroundColor: colors.card, borderColor: colors.border }]}
      onPress={() => (isRegistered && participant.userId ? onPress(participant.userId) : null)}
      activeOpacity={isRegistered ? 0.7 : 1}
      disabled={!isRegistered}
    >
      <View style={styles.participantInfo}>
        <Text style={[styles.seedBadge, { backgroundColor: colors.primary }]}>#{participant.seed}</Text>
        <View style={styles.participantDetails}>
          <View style={styles.participantNameRow}>
            <Text style={[styles.participantName, { color: colors.text }]}>{participant.name}</Text>
            {participant.userId && (
              <Ionicons name="person-circle" size={16} color={colors.primary} style={{ marginLeft: 6 }} />
            )}
          </View>
          {participant.userId && participant.userEmail && (
            <Text style={[styles.participantEmail, { color: colors.textSecondary }]}>{participant.userEmail}</Text>
          )}
        </View>
      </View>
      {isSetup && canManageParticipants && !isChallengeTournament && (
        <TouchableOpacity
          onPress={() => onDelete(participant.id)}
          style={[styles.deleteButton, { backgroundColor: colors.error }]}
        >
          <Ionicons name="close" size={18} color="#fff" />
        </TouchableOpacity>
      )}
    </TouchableOpacity>
  );
};
